import { createContext, useContext, useEffect, useState } from 'react';
import { type OneOfProfileSections, profileSections } from './profileSections';

interface ActiveSectionContextType {
  activeSection: OneOfProfileSections;
  setActiveSection: (section: OneOfProfileSections) => void;
  targetSection: OneOfProfileSections | null;
  setTargetSection: (section: OneOfProfileSections | null) => void;
  isRouterDeviceManagementSection: boolean;
  setIsRouterDeviceManagementSection: (state: boolean) => void;
}

const ActiveSectionContext = createContext<ActiveSectionContextType | undefined>(undefined);

export const ActiveSectionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [activeSection, setActiveSection] = useState<OneOfProfileSections>(profileSections.ACCOUNT);
  const [targetSection, setTargetSection] = useState<OneOfProfileSections | null>(null);
  const [isRouterDeviceManagementSection, setIsRouterDeviceManagementSection] = useState<boolean>(false);

  useEffect(() => {
    if (activeSection !== profileSections.DEVICES) {
      setTargetSection(null);
      setIsRouterDeviceManagementSection(false);
    }
  }, [activeSection]);

  return (
    <ActiveSectionContext.Provider
      value={{
        activeSection,
        setActiveSection,
        targetSection,
        setTargetSection,
        isRouterDeviceManagementSection,
        setIsRouterDeviceManagementSection,
      }}
    >
      {children}
    </ActiveSectionContext.Provider>
  );
};

export const useActiveSectionContext = (): ActiveSectionContextType => {
  const context = useContext(ActiveSectionContext);

  if (!context) {
    throw new Error('useActiveSectionContext must be used within an ActiveSectionProvider');
  }

  return context;
};
